import { Link } from "react-router-dom";
import { ArrowLeft, Save, Send, Eye, Loader2 } from "lucide-react";

export function QuoteFormHeader({ slug, saving, sending, onSave, onSaveAndSend }) {
  return (
    <header className="border-b border-[#E5E3DB] bg-white/70 backdrop-blur-xl sticky top-0 z-40">
      <div className="px-6 md:px-12 lg:px-16 py-5 flex items-center justify-between gap-4 flex-wrap">
        <Link
          to="/admin"
          className="inline-flex items-center gap-2 text-xs tracking-overline uppercase text-[#5C5A56] hover:text-[#1F1E1D]"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
          All quotes
        </Link>
        <div className="flex items-center gap-2">
          {slug && (
            <Link
              to={`/q/${slug}`}
              target="_blank"
              data-testid="preview-quote-btn"
              className="inline-flex items-center gap-2 text-[#5C5A56] hover:text-[#1F1E1D] px-4 py-3 text-xs tracking-overline uppercase font-medium border border-[#D1CEC2] hover:border-[#1F1E1D] transition-colors"
            >
              <Eye className="w-4 h-4" strokeWidth={1.5} />
              Preview
            </Link>
          )}
          <button
            onClick={onSave}
            disabled={saving}
            data-testid="save-quote-btn"
            className="inline-flex items-center gap-2 border border-[#2F2E2E] text-[#2F2E2E] hover:bg-[#2F2E2E] hover:text-white px-5 py-3 text-xs tracking-overline uppercase font-medium transition-colors disabled:opacity-60"
          >
            {saving ? (
              <Loader2 className="w-4 h-4 animate-spin" strokeWidth={1.5} />
            ) : (
              <Save className="w-4 h-4" strokeWidth={1.5} />
            )}
            Save
          </button>
          <button
            onClick={onSaveAndSend}
            disabled={saving || sending}
            data-testid="save-and-send-btn"
            className="inline-flex items-center gap-2 bg-[#2F2E2E] text-white hover:bg-[#454341] px-5 py-3 text-xs tracking-overline uppercase font-medium transition-colors disabled:opacity-60"
          >
            {sending ? (
              <Loader2 className="w-4 h-4 animate-spin" strokeWidth={1.5} />
            ) : (
              <Send className="w-4 h-4" strokeWidth={1.5} />
            )}
            Save & Send
          </button>
        </div>
      </div>
    </header>
  );
}
